import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TransactionDbService } from './transaction-db.service';
import { Transaction } from './transaction.models';

@Injectable({ providedIn: 'root' })
export class TransactionService {
  private transactionDbService = inject(TransactionDbService);

  /**
   * Returns a real-time observable of a transaction document.
   * @param id Transaction document identifier.
   */
  getTransaction$(id: string): Observable<Transaction> {
    return this.transactionDbService.get$(id);
  }

  /**
   * Fetches a transaction document once (one-shot).
   * @param id Transaction document identifier.
   */
  getTransaction(id: string): Promise<Transaction> {
    return this.transactionDbService.get(id);
  }
}
